import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { SWAlertService } from '../../services/swalert.service';
import { Router, Data } from '@angular/router';
import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';
import { isUndefined } from 'util';
import { any } from '@amcharts/amcharts4/.internal/core/utils/Array';

@Component({
  selector: 'app-holiday',
  templateUrl: './holiday.component.html',
  styleUrls: ['./holiday.component.css']
})
export class HolidayComponent implements OnInit {
  HolidayForm: FormGroup;//สร้างกลุ่ม Object Data
  get f() { return this.HolidayForm.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน
  constructor(private formBuilder: FormBuilder,
    private http: HttpClient,
    private System: TSFuntionService,
    private SW: SWAlertService,
    private router: Router,
    public datepipe: DatePipe) { }
  _nYear = [];
  Year = new Date().getFullYear();
  nYear: any;
  DataHolidays: any; //ตัวแปรรับค่า holiday
  ArrHolidays = []; //ตัวแปรเก็บ dDate วันหยุด
  DataFilterYear: any = []; //ตัวแปรเก็บ dDate วันหยุด
  DataFilterStatus: any = []; //ตัวแปรเก็บ dDate วันหยุด
  DataYear: any = [];
  DataAll: any = [];
  nHolidayID: string = null;
  ArrDataAll = [];
  IsEdit: boolean = false;
  cbnHolidayID = false;
  IsAll: boolean = false;
  IsDelete: boolean = false;
  ArrDelete: any[] = [];
  bsValue = new Date();
  MinDate: Date;
  MaxDate: Date;
  IsShow: boolean = true;
  IsShowNextYear: boolean = false;
  DupData: boolean = false;
  ResultPermission: boolean = false;
  ResultPermissionMunu: boolean = false;
  IsViewMode: boolean = false;

  public settings = {};

  async ngOnInit() {
    this.System.BlockUI();

    this.HolidayForm = this.formBuilder.group({ //ประกาศ FormControl จากหน้า html
      nHolidayID: [null],
      nYear: [null, Validators.required],
      nNextYear: [null, Validators.required],
      sHolidayName: [null, Validators.required],
      dDate: [new Date(), Validators.required],
      cActive: [1, Validators.required]
    });

    this.MinDate = new Date();
    this.MaxDate = new Date(new Date().getFullYear(), 11, 31);

    this.settings = {
      singleSelection: false,
      idField: 'sText',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    await this.SetDataOnPageLoad();
    //await this.GetYear();
    this.GetData();

    //Check Permission Menu
    let ObjData = {
      sRequestID: "",
      nMenuID: 13
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (this.ResultPermission) {
      //Check Permission Admin
      this.ResultPermissionMunu = await this.System.CheckPermissionMeun(13);
      if (!this.ResultPermissionMunu) {
        this.HolidayForm.controls.nYear.disable();
        this.HolidayForm.controls.nNextYear.disable();
        this.HolidayForm.controls.sHolidayName.disable();
        this.HolidayForm.controls.dDate.disable();
        this.HolidayForm.controls.cActive.disable();

        this.IsViewMode = true;
      }
    }

    this.System.UnBlockUI();
  }

  //#region Set Data On Page Load
  async SetDataOnPageLoad() {
    this.System.BlockUI();
    //method SetDataOnPageLoad ใช้ดึงข้อมูลจาก database มาจาก controller
    //Year ดึงปีที่น้อยที่สุด
    let _this = this;
    const httpOptions_TM_Holiday = { //ประกาศตัวแปรเพื่อส่งค่าไปยัง HttpGet
      headers: new HttpHeaders({ //ใช้ส่งค่าในการกำหนดรูปแบบการส่งข้อมูลไปยัง HttpGet
        'Content-Type': 'application/json' //ประเภทรูปแบบ Json
      }),
    };
    this.http.get(this.System.SiteName + "api/Holiday/GetTM_Holiday", httpOptions_TM_Holiday).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this.DataHolidays = res; //ตัวแปร array object เก็บค่าจากตาราง TM_Holiday
        this.ArrHolidays = this.DataHolidays.map(m =>
          m.nYear
        );
        this.nYear = Math.min.apply(null, this.ArrHolidays);
        this.HolidayForm.controls.nYear.setValue(new Date().getFullYear()); //default year now
      }
    });
    
    this.GetFilterYear();

    //MinYear
    await this.http.get<any>(this.System.SiteName + "api/Holiday/GetMinYear").subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this.DataYear = res;
      }
      this.GetYear();
    });
  }
  //#endregion

  GetFilterYear(){
    this.http.get<any>(this.System.SiteName + "api/Holiday/GetFilterYear").subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this.DataFilterYear = res;
      }
    });
  }

  //#region Get Year
  GetYear() { //set drop down list => year จากปีน้อยสุด +1
    if (this.DataYear.length > 0) {
      this._nYear = this.DataYear;
    }
    
    for (var i = 0; i < 5; i++) {
      let oYear = this._nYear.filter(f => f.nYear == this.Year);
      if (oYear.length == 0) {
        this._nYear.push({
          nYear: this.Year
        });
      }
      this.Year++;
    }
  }
  //#endregion

  //#region On Change Datepicker by Dropdownlist Year
  onSelect_ddlYear() {
    let nYear = this.HolidayForm.controls.nYear.value; //get value from control
    let Today = new Date; //get now today

    if (nYear) { //select nYear
      this.bsValue = new Date(Today.setFullYear(nYear)); //set date
    }

    //set datepicker by year
    this.MinDate = new Date(nYear, 0, 1);
    this.MaxDate = new Date(nYear, 11, 31);

    this.HolidayForm.get("dDate").markAsUntouched({ onlySelf: true });
    this.HolidayForm.controls["dDate"].setValidators(Validators.required);//กำหนด Validate
    this.HolidayForm.controls["dDate"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.HolidayForm.controls["dDate"].updateValueAndValidity();//Update Validate
  }
  //#endregion

  //#region ตัวแปรในการทำงาน
  //Standard Data Grid
  FilterGrid = {
    sSearch: "",
    nYear: [],
    dDate: "",
    cActive: ""
  }
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-down";
  IcoSortAsc = "fas fa-sort-up";
  sDetailData = "";
  _ArrData = [];
  _ArrDataBind = [];
  _ArrDataAll = [];
  //#endregion

  //#region Header Colomn
  Columns = [
    { ColumnName: "Date", SortField: "dDate", Width: "15%" },
    { ColumnName: "Date Name", SortField: "sHolidayName", Width: "60%" },
    { ColumnName: "Status", SortField: "Status", Width: "10%" },
    { ColumnName: "", SortField: "", Width: "8%" }
  ]
  //#endregion

  //#region Event
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
    });
    this.BindDataTable();
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion

  //#region Get Data
  GetData() {
    this.System.BlockUI();
    let _nFilterYear: string = this.FilterGrid.nYear.length > 0 ? this.FilterGrid.nYear.map(e => e.sText).join(",") : "";
    let _date = this.FilterGrid.dDate == "" ? "" : Intl.DateTimeFormat("en").format(new Date(this.FilterGrid.dDate));

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('nYear', _nFilterYear)
        .set('sStatus', this.FilterGrid.cActive)
        .set('dDate', _date)
    };
    this.http.get<any>(this.System.SiteName + "api/Holiday/ListData", httpOptions).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this._ArrDataAll = res.map(m => ({
          nHolidayID: m.nHolidayID,
          nYear: m.nYear,
          sDate: m.sDate,
          dDate: m.dDate,
          sHolidayName: m.sHolidayName,
          Status: m.Status
        }));
        this._ArrData = this._ArrDataAll;
      }
      else {
        this.System.UnBlockUI();
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }
  //#endregion

  //#region BindDataTable
  BindDataTable() {
    this.System.BlockUI();
    let user = this.System.GetUserStorage();
    let nRole = user.nRole
    //let status = this.Getstatus(nRole);
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " Rows";
    this.System.UnBlockUI();
  }
  //#endregion

  //#region NumberOnly
  numberOnly(event): boolean { //method กรอกข้อมูลเฉพาะตัวเลข
    const charCode = event.key;
    var regExp = new RegExp('[A-Za-z]', 'g');
    if (regExp.test(charCode)) {
      return false;
    } else {
      return true;
    }
  }
  //#endregion

  //#region Check All
  CheckAll() {
    if (this.IsAll) {
      this.IsDelete = true;
    } else {
      this.IsDelete = false;
    }
    this._ArrDataBind.forEach(f => f.IsDelete = this.IsAll);
  }
  //#endregion

  //#region Check Delete
  checkDel() {
    this.IsDelete = this._ArrDataBind.filter(f => f.IsDelete == true).length > 0 ? true : false;
  }
  //#endregion

  //#region On Click
  onClick(value: string) {
    let _this = this;
    switch (value) {
      case "Submit":

        let FieldValid: string[] = [];
        let IsValid: boolean = true;
        let _FormGroup = this.HolidayForm;

        if (this.DupData) {
          if (!this.HolidayForm.get('nNextYear').valid) {//check validate nNextYear
            const control = this.HolidayForm.get('nNextYear');
            if (control instanceof FormControl) {
              control.markAsTouched({ onlySelf: true });
            }
          } else {
            this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, function () { _this.Save() }, undefined);
          }
        } else {
          FieldValid = ["nYear", "sHolidayName", "dDate", "cActive"];
          FieldValid.forEach(function (Field) { //check validate
            if (!_FormGroup.get(Field).valid) {
              IsValid = false;
            }
          });

          if (IsValid) {
            this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, function () { _this.Save() }, undefined);
          } else {
            if (FieldValid.length != 0) {
              FieldValid.forEach(function (Field) {
                const control = _FormGroup.get(Field);
                if (control instanceof FormControl && control.status != "DISABLED") {
                  control.markAsTouched({ onlySelf: true });
                }
              });
            }
          }
        }
        break;
      case "Back":
        this.router.navigate(["/admin-menu"]);
        break;
      case "Reset":
        this.Reset();
        break;
      case "Delete":
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () { _this.Delete() }, undefined)
        break;
      case "Duplicate":
        this.DuplicateData();
        break;
      default:
    }
  }
  //#endregion

  //#region Validate
  isFieldValid(field: string) {
    return !this.HolidayForm.get(field).valid && this.HolidayForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Check Duplicate Data
  async CheckDuplicateData() {
    this.System.BlockUI();

    let dDate = this.HolidayForm.controls['dDate'].value; //get date
    if (typeof dDate == "string") {
      dDate = this.convertTodate(dDate);
    }
    let dDateFormat = this.datepipe.transform(dDate, 'dd/MM/yyyy'); //convert format

    let Result = { IsPass: true, Msg: "" };

    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('dDate', dDateFormat)
    };
    await this.http.get<any>(this.System.SiteName + "api/Holiday/CheckDuplicateData", httpOptions).toPromise().then(res => {
      if (res) {
        if (res.length > 0) {
          if (res[0].IsDelete) {
            this.System.UnBlockUI();
            Result.IsPass = true;
            this.nHolidayID = res[0].nHolidayID + "";
          } else if (this.IsEdit) {
            this.System.UnBlockUI();
            Result.IsPass = true;
            this.nHolidayID = res[0].nHolidayID + "";
          } else {
            this.System.UnBlockUI();
            Result.IsPass = false;
          }
        } else {
          this.System.UnBlockUI();
          Result.IsPass = true;
        }
      } else {
        this.System.UnBlockUI();
        Result.IsPass = false;
      }
    });
    return Result;
  }
  //#endregion

  //#region Button DuplicateData
  DuplicateData() {
    this.IsShow = false;
    this.IsShowNextYear = true;
    this.DupData = true;
  }
  //#endregion

  //#region Save
  async Save() {
    this.System.BlockUI();

    //get ID
    let _this = this;
    let nHolidayID;
    if (!isUndefined(this.nHolidayID) || this.nHolidayID != null) {
      nHolidayID = this.nHolidayID;
    } else {
      nHolidayID = "";
    }

    //get date
    let dDate = this.HolidayForm.controls['dDate'].value;
    if (typeof dDate == "string") {
      dDate = this.convertTodate(dDate);
    }
    let dDateFormat = this.datepipe.transform(dDate, 'dd/MM/yyyy');

    //get nYear,nNextYear
    let nYear = this.HolidayForm.controls.nYear.value + "";
    let nNextYear = this.HolidayForm.controls.nNextYear.value + "";

    if (this.DupData) { //save duplicate data

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      };
      let Obj_Data = {
        nYear: nYear,
        nNextYear: nNextYear
      }
      this.http.post<any>(this.System.SiteName + "api/Holiday/SaveDuplicate", Obj_Data, httpOptions).toPromise().then(res => {
        this.System.UnBlockUI();
        if (res.Status == this.System.SysProcess.SessionExpired) {
          this.System.SessionExpire();
        } else if (res.Status == this.System.SysProcess.Success) {
          this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_SaveComplete, function () {
            _this.GetData();
            _this._ArrData = [];
            _this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
            _this.BindDataTable();
            _this.Reset();
            _this.GetFilterYear();
          });
          this.IsShow = true;
          this.IsShowNextYear = false;
          this.DupData = false;
          this.IsEdit = false;
        } else {
          this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, res.Status, function () {
            Swal.close();
          });
          this.IsShow = true;
          this.IsShowNextYear = false;
          this.DupData = false;
          this.IsEdit = false;
        }
      });
    } else { //create , update
      let result: any = await this.CheckDuplicateData();//check duplicate

      if (result.IsPass) {
        //Check ReqID
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          }),
        };
        //let formObj = this.HolidayForm.getRawValue();
        let _TM_Holiday = {
          nYear: this.HolidayForm.controls.nYear.value + "",
          sHolidayName: this.HolidayForm.controls.sHolidayName.value,
          cActive: this.HolidayForm.controls.cActive.value == 1 ? "Y" : "N"
        }
        let Obj_Data = {
          nHolidayID: this.nHolidayID,
          dDate: dDateFormat,
          TM_Holiday: _TM_Holiday
        }
        this.http.post<any>(this.System.SiteName + "api/Holiday/Save", Obj_Data, httpOptions).toPromise().then(res => {
          this.System.UnBlockUI();
          if (res.Status == this.System.SysProcess.SessionExpired) {
            this.System.SessionExpire();
          } else if (res.Status == this.System.SysProcess.Success) {
            this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_SaveComplete, function () {
              _this.GetData();
              _this._ArrData = [];
              _this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
              _this.BindDataTable();
              _this.Reset();
              _this.GetFilterYear();
            });
          } else {
            this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, res, function () {
              Swal.close();
            });
          }
        });
        this.DupData = false;
        this.IsEdit = false;
      } else {
        this.System.UnBlockUI();
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, this.SW.BoxMsg.Desc_Warning_Duplicate, function () { });
        this.DupData = false;
        this.IsEdit = false;
      }
    }
    this.GetFilterYear();
  }
  //#endregion

  //#region Edit
  async Edit(nHolidayID: any) {
    let _this = this;
    this.System.BlockUI();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('nHolidayID', nHolidayID)
    };
    this.http.get(this.System.SiteName + 'api/Holiday/Edit', httpOptions).toPromise().then(res => {
      if (res) {
        this.System.UnBlockUI();
        this.DataAll = res;
        this.nHolidayID = res[0].nHolidayID + "";
        this.HolidayForm.patchValue({
          nHolidayID: res[0].nHolidayID,
          nYear: res[0].nYear,
          sHolidayName: res[0].sHolidayName,
          dDate: res[0].sDate,
          cActive: res[0].cActive == "Y" ? 1 : 2
        });
        //this.onSelect_ddlYear();
      } else {
        this.System.UnBlockUI();
        this.HolidayForm.patchValue({
          nHolidayID: "",
          nYear: "",
          sHolidayName: "",
          dDate: "",
          cActive: ""
        });
      }
      document.getElementById('Top').scrollIntoView({ behavior: "smooth" }); //scroll to top
      this.IsEdit = true;
      this.IsShow = true;
      this.DupData = false;
      this.IsShowNextYear = false;
    });
  }
  //#endregion

  //#region Reset
  Reset() {
    this.System.BlockUI();

    this.HolidayForm.get("nYear").markAsUntouched({ onlySelf: true });
    this.HolidayForm.get("sHolidayName").markAsUntouched({ onlySelf: true });
    this.HolidayForm.get("dDate").markAsUntouched({ onlySelf: true });
    this.HolidayForm.get("cActive").markAsUntouched({ onlySelf: true });

    this.HolidayForm.controls["nYear"].setValue(new Date().getFullYear());//Set ค่า
    this.HolidayForm.controls["sHolidayName"].setValue("");//Set ค่า
    this.HolidayForm.controls["dDate"].setValue(new Date);//Set ค่า
    this.HolidayForm.controls["cActive"].setValue(1);//Set ค่า

    this.HolidayForm.controls["nYear"].setValidators(Validators.required);//กำหนด Validate
    this.HolidayForm.controls["sHolidayName"].setValidators(Validators.required);//กำหนด Validate
    this.HolidayForm.controls["dDate"].setValidators(Validators.required);//กำหนด Validate
    this.HolidayForm.controls["cActive"].setValidators(Validators.required);//กำหนด Validate

    this.HolidayForm.controls["nYear"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.HolidayForm.controls["sHolidayName"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.HolidayForm.controls["dDate"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.HolidayForm.controls["cActive"].setErrors(null);//ปรับ Control ให้เป็นปกติ

    this.HolidayForm.controls["nYear"].updateValueAndValidity();//Update Validate
    this.HolidayForm.controls["sHolidayName"].updateValueAndValidity();//Update Validate
    this.HolidayForm.controls["dDate"].updateValueAndValidity();//Update Validate
    this.HolidayForm.controls["cActive"].updateValueAndValidity();//Update Validate

    this.DupData = false;
    this.IsShow = true;
    this.IsShowNextYear = false;
    this.IsEdit = false;

    this.System.UnBlockUI();
  }
  //#endregion

  //#region ClearFilter
  ClearFilter() {
    let _this = this;
    this.FilterGrid.sSearch = "";
    this.FilterGrid.nYear = [];
    this.FilterGrid.dDate = "";
    this.FilterGrid.cActive = "";
    this.GetData();
    this._ArrData = [];
    this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
    this.BindDataTable();
    this.Reset();
  }
  //#endregion

  //#region Delete
  Delete() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this._ArrDataBind.forEach(f =>
      this.ArrDelete.push({
        nHolidayID: f.nHolidayID + "",
        IsDelete: f.IsDelete
      }));
    let ITEM = JSON.stringify(this.ArrDelete);
    this.http.post<any>(this.System.SiteName + 'api/Holiday/Delete', ITEM, httpOptions).toPromise().then(res => {
      this.System.UnBlockUI();
      if (res.Status == this.System.SysProcess.Success) {
        this.SW.SwAlert.Success(this.SW.BoxMsg.Title_Success, this.SW.BoxMsg.Desc_Success_Delete, function () {
          _this.GetData();
          _this._ArrData = [];
          _this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
          _this.BindDataTable();
          _this.GetFilterYear();
        });
        this.IsDelete = false;
        this.DupData = false;
        this.IsEdit = false;
      }
      else {
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
        this.IsDelete = false;
        this.DupData = false;
        this.IsEdit = false;
      }
    });
  }
  //#endregion

  //#region CheckBoxs
  CheckBoxs() {
    var AllCkeck = [];
    var Checkboxes = document.getElementsByTagName('input');
    for (var i = 0; i < Checkboxes.length; i++) {
      if (Checkboxes[i].type == 'checkbox' &&
        Checkboxes[i].checked == true &&
        Checkboxes[i].name == "cbnHolidayID") {
        AllCkeck.push(Checkboxes[i].value);
      }
    }
  }
  //#endregion

  convertTodate(dDate) {
    let chunks = dDate.split('/');
    return new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
  }
}

